import { render, staticRenderFns } from "./DesktopStatic.vue?vue&type=template&id=1b944e34&"
import script from "./DesktopStatic.vue?vue&type=script&lang=js&"
export * from "./DesktopStatic.vue?vue&type=script&lang=js&"
import style0 from "./DesktopStatic.vue?vue&type=style&index=0&id=1b944e34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports